module.exports = __webpack_public_path__ + "assets/img/AdditionReward_bg.8f371f26.png";